import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./Workbook.scss";
import PropTypes from "prop-types";
import FileViewer from "UIComponents/FileViewer";
import DialogueBox from "UIComponents/DialogueBox";
import UIModal from "UIComponents/UIModal";
import I18nHOC from "UIComponents/I18nHOC";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import Loading from "UIComponents/Loading";
import CompactLEPreview from "AppComponents/CompactLEPreview";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import {
  getWorkBookUrl,
  getWorkBookMessagePayload,
  getAttachmentIdForUploadedAttachment,
  WORKBOOK_MODE_TYPES,
  WORKBOOK_IFRAME_ID_SELECTORS,
} from "Utils";
import { getWorkbookOrigin } from "Utils/WorkbookHelpers";
import { getAttachment } from "modules/Services";
import {
  setToastMsg,
  getUserInfo,
  setGlobalTrayEnabledState,
  logoutUser,
} from "Login/modules/LoginModule";
import WorkbookIframePortal from "./WorkbookIframePortal";
import { GiveFeedbackIcon } from "SvgComponents";
import { WORK_BOOK_URL } from "Constants";
import { SNPv2_VISITOR_PORTAL_PERM_GROUP } from "Constants/permissionConstants";
import ACLStore from "lib/aclStore";
import { TODDLE_LIBRARY } from "Constants/stringConstants";
import { Sentry } from "services/sentry";
import {
  updateIsQuestionTheaterModeEnable,
  updateEnableAutoSubmit,
} from "Worksheet/modules/WorksheetModules";
import { isSafeExamBrowser, isInKioskMode } from "Utils/DeviceDetectHelpers";

const styles = {
  modalBodyStyle: {
    marginTop: "0",
    padding: "8px 48px 48px 48px",
    flex: "0",
  },
  cancelButtonStyle: {
    flexBasis: "0%",
    marginRight: "0",
  },
  cancelButtonProps: {
    color: "transparent",
    type: "hollow",
    disableHover: true,
  },
};

const DIALOGUE_INFO = {
  DISCARD: {
    title: ({ t }) => {
      return t("common:discard_changes");
    },
    modalBody: ({ t }) => {
      return (
        <div className={classes.modalBody}>
          {t("classRoom:discard_feedback_warning_msg")}
        </div>
      );
    },
    confirmButtonText: t => t("common:discard_exit"),
    cancelButtonText: t => t("common:cancel"),
  },
};

class Workbook extends PureComponent {
  constructor(props) {
    super(props);

    //initialize variable
    this.loadWorkbookCachedVersion =
      props.shouldEnablePreload &&
      ACLStore.can("FeatureFlag:WorkbookPreloadWeb");
    this.isWorkBookPreLoaded = false;
    this.isWorkbookIntialised = false;
    this.iframeRef = null;
    this.countLoadingEvents = 0;
    this.pendingRequests = new Map();

    this.state = {
      currentDialogAction: null,
      showFullScreenLoader: true,
      isLoaded: false,
      waitForRef: false,
      instructionsModalVisible: false,
    };
    this.invokeWorkbookCustomLoader({ isLoading: true });
    if (this.loadWorkbookCachedVersion) {
      //check if workbook-global-iframe is already present
      const { iframeIdSelector, parentRef } = this.props;
      const getIframe = document.getElementById(iframeIdSelector);
      if (getIframe && _.get(getIframe, "src", "")) {
        this.isWorkBookPreLoaded = true;
        this.iframeRef = getIframe;
        this.isWorkbookIntialised = true;
      }
      // this.state.waitForRef = false;

      if (
        _.isEqual(
          iframeIdSelector,
          WORKBOOK_IFRAME_ID_SELECTORS["CLASSROOM"]
        ) &&
        (_.isNull(parentRef) || _.isNull(parentRef?.current))
      ) {
        // this.waitForRef = true;
        this.state.waitForRef = true;
        // this.setState({ waitForRef: true });
        this.iframeRef = null;
      }
    }
  }

  componentDidMount() {
    const {
      setGlobalTrayEnabledState,
      workbookMode,
      updateIsQuestionTheaterModeEnable,
      isDrawingQuestion,
    } = this.props;

    const { workbookCompRef } = this.props;
    // store reference of workbook component in workbookCompRef
    if (workbookCompRef && _.has(workbookCompRef, "current")) {
      workbookCompRef.current = this;
    }

    if (
      isDrawingQuestion &&
      _.includes(
        [
          WORKBOOK_MODE_TYPES["WORKSHEET_STUDENT_MOBILE_EDIT"],
          WORKBOOK_MODE_TYPES["WORKSHEET_STUDENT_SEB_EDIT"],
          WORKBOOK_MODE_TYPES["WORKSHEET_STUDENT_EDIT"],
        ],
        workbookMode
      )
    ) {
      updateIsQuestionTheaterModeEnable(true);
    }
    if (
      !_.includes(
        [
          "WORKBOOK_VIEW",
          "WORKBOOK_FEEDBACK_VIEW",
          "WORKBOOK_TEMPLATE_PREVIEW",
        ],
        workbookMode
      )
    ) {
      setGlobalTrayEnabledState(false);
    }
    window.addEventListener("message", this.handleMessageFromWorkbook, false);
    if (!this.loadWorkbookCachedVersion) return;
    if (this.state.waitForRef) {
      const { parentRef } = this.props;

      if (!_.isNull(parentRef) && !_.isNull(parentRef?.current)) {
        this.updateTheatreModeStyles();
        // this.waitForRef = false;
        if (this.state.waitForRef) {
          this.setState({ waitForRef: false });
        }
      } else {
        return;
      }
    }
    this.onWorkbookMount();
  }

  UNSAFE_componentWillUpdate() {
    if (!this.loadWorkbookCachedVersion) return;
    const { iframeIdSelector, parentRef } = this.props;

    if (
      _.isEqual(iframeIdSelector, WORKBOOK_IFRAME_ID_SELECTORS["CLASSROOM"])
    ) {
      this.updateTheatreModeStyles();
      if (!_.isNull(parentRef) && !_.isNull(parentRef?.current)) {
        // this.waitForRef = false;
        if (this.state.waitForRef) {
          this.setState({ waitForRef: false });
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      isDrawingQuestion,
      enableAutoSubmit,
      updateEnableAutoSubmit,
      attachment,
    } = this.props;
    if (this.loadWorkbookCachedVersion) {
      if (this.state.waitForRef) {
        const { parentRef } = this.props;

        if (!_.isNull(parentRef) && !_.isNull(parentRef?.current)) {
          this.updateTheatreModeStyles();
          // this.waitForRef = false;
          if (this.state.waitForRef) {
            this.setState({ waitForRef: false });
          }
        }
      }
      if (
        !_.isEqual(
          _.get(this.props, "attachment", {}),
          _.get(prevProps, "attachment", {})
        )
      ) {
        this.onWorkbookMount();
      }
    }
    if (
      !_.isEqual(
        _.get(prevState, "showFullScreenLoader"),
        _.get(this.state, "showFullScreenLoader")
      )
    ) {
      this.invokeWorkbookCustomLoader({
        isLoading: this.state.showFullScreenLoader,
      });
    }
    if (isDrawingQuestion && enableAutoSubmit) {
      this.sendMessage({ MESSAGE_TOKEN: "SAVE_DRAWING_QUESTION" });
      updateEnableAutoSubmit(false);
    }
  }

  invokeWorkbookCustomLoader = ({ isLoading }) => {
    const { invokeWorkbookCustomLoader } = this.props;
    if (invokeWorkbookCustomLoader) {
      invokeWorkbookCustomLoader({
        isLoading,
      });
    }
  };

  focusIframeHandler = () => this.iframeRef?.focus();

  addFocusListeners = helperId => {
    const helperDiv = document.getElementById(helperId);
    if (helperDiv) {
      helperDiv.addEventListener("focus", this.focusIframeHandler);
    }
  };

  removeFocusListeners = helperId => {
    const helperDiv = document.getElementById(helperId);
    if (helperDiv) {
      helperDiv.removeEventListener("focus", this.focusIframeHandler);
    }
  };

  enableFullscreenFocusTrap = () => {
    const { isFullScreen, iframeIdSelector } = this.props;
    if (
      _.isEqual(iframeIdSelector, WORKBOOK_IFRAME_ID_SELECTORS["DEFAULT"]) &&
      isFullScreen
    ) {
      const helperDivIds = [
        `${iframeIdSelector}_helper_div_1`,
        `${iframeIdSelector}_helper_div_2`,
      ];

      // Add listeners
      _.forEach(helperDivIds, this.addFocusListeners);
    }
  };

  onWorkbookMount = () => {
    if (this.iframeRef && this.iframeRef.style) {
      this.updateTheatreModeStyles();
      this.iframeRef.style.display = "block";
      if (this.isWorkBookPreLoaded || this.isWorkbookIntialised) {
        this.handleMessageEventToWorkbook();
      }
      this.setState({ showFullScreenLoader: false, isLoaded: true });
      if (
        this.iframeRef &&
        !_.isEqual(document.activeElement, this.iframeRef) &&
        _.get(this.props, "shouldFocusWorkbook", true)
      ) {
        this.iframeRef?.focus();
      }
      this.enableFullscreenFocusTrap();
    }
  };

  updateTheatreModeStyles = () => {
    const { iframeIdSelector } = this.props;
    if (
      _.isEqual(iframeIdSelector, WORKBOOK_IFRAME_ID_SELECTORS["CLASSROOM"])
    ) {
      const TheatreModeComponent = document.getElementById(
        WORKBOOK_IFRAME_ID_SELECTORS["THEATRE_MODE"]
      );
      if (TheatreModeComponent) {
        TheatreModeComponent.style.height = "0%";
      }
    }
  };

  componentWillUnmount() {
    const {
      iframeIdSelector,
      setGlobalTrayEnabledState,
      updateIsQuestionTheaterModeEnable,
      isDrawingQuestion,
      workbookMode,
      workbookCompRef,
    } = this.props;

    // clean up workbookCompRef
    if (workbookCompRef && workbookCompRef.current) {
      workbookCompRef.current = null;
    }

    if (
      isDrawingQuestion &&
      _.includes(
        [
          WORKBOOK_MODE_TYPES["WORKSHEET_STUDENT_MOBILE_EDIT"],
          WORKBOOK_MODE_TYPES["WORKSHEET_STUDENT_SEB_EDIT"],
          WORKBOOK_MODE_TYPES["WORKSHEET_STUDENT_EDIT"],
        ],
        workbookMode
      )
    ) {
      updateIsQuestionTheaterModeEnable(false);
    }

    const url = new URL(window.location.href);
    const isWorksheetWebView = url?.searchParams?.get("isWorksheetWebView");
    const isInSafeExamBrowser = isSafeExamBrowser();

    if (
      !isWorksheetWebView &&
      !isInSafeExamBrowser &&
      !(isInKioskMode() && isInSafeExamBrowser)
    ) {
      setGlobalTrayEnabledState(true);
    }

    /** Hide loader when the workbook unmounts */
    this.invokeWorkbookCustomLoader({ isLoading: false });

    window.removeEventListener(
      "message",
      this.handleMessageFromWorkbook,
      false
    );

    // Clean up pending requests
    if (this.pendingRequests) {
      this.pendingRequests.forEach(({ timeout, reject, shouldThrowError }) => {
        clearTimeout(timeout);
        if (shouldThrowError) {
          reject(new Error("Component unmounted"));
        }
      });
      this.pendingRequests.clear();
    }

    if (!this.loadWorkbookCachedVersion) return;
    //send clear canvas method to workbook
    this.sendMessage({ MESSAGE_TOKEN: "RESET_SETTINGS" });
    if (this.iframeRef && this.iframeRef.style) {
      this.iframeRef.style.display = "none";
      if (_.isEqual(document.activeElement, this.iframeRef)) {
        this.iframeRef?.blur();
      }
    }
    if (
      _.isEqual(iframeIdSelector, WORKBOOK_IFRAME_ID_SELECTORS["CLASSROOM"])
    ) {
      const TheatreModeComponent = document.getElementById(
        WORKBOOK_IFRAME_ID_SELECTORS["THEATRE_MODE"]
      );
      if (TheatreModeComponent) {
        TheatreModeComponent.style.height = "100%";
      }
    }
    //remove focusIframeHandler
    const helperDivIds = [
      `${iframeIdSelector}_helper_div_1`,
      `${iframeIdSelector}_helper_div_2`,
    ];

    // Add listeners
    _.forEach(helperDivIds, this.removeFocusListeners);
  }
  /* iframe messaging code starts here */
  // Send a message to the child iframe
  sendMessage = msg => {
    if (!_.isString(msg)) {
      msg = JSON.stringify(msg);
    }
    if (this.iframeRef) {
      const targetOrigin = getWorkbookOrigin();
      this.iframeRef?.contentWindow?.postMessage(msg, targetOrigin);
    }
  };

  /*
    Used only for iframe communication , which awaits response from iframe
    currently supported only for few message tokens, use sendMessage by default
  */
  sendMessageV2 = async ({ MESSAGE_TOKEN, PAYLOAD = {} }) => {
    const { iframeIdSelector } = this.props;

    return new Promise((resolve, reject) => {
      const message = {
        MESSAGE_TOKEN,
        PAYLOAD,
        requestId: Date.now() + Math.random(), // Unique ID for this request
        // TODO: Use generateRandomIdV2 from Utils to generate requestId
      };

      let iframeRef = this.iframeRef;
      if (!iframeRef) {
        iframeRef = document.getElementById(iframeIdSelector);
      }

      if (!iframeRef) {
        console.warn(
          "Iframe reference not found for sending message:",
          iframeIdSelector
        );
        reject(new Error("Iframe reference not found"));
        return;
      }

      // Store the promise resolver for this specific request
      const timeout = setTimeout(() => {
        this.pendingRequests.delete(message.requestId);
        if (MESSAGE_TOKEN === "SAVE_AI_TUTOR_RESPONSE")
          reject(new Error(`Request timeout for ${MESSAGE_TOKEN}`)); //TODO: show toast message
      }, 30000); // 30 second timeout

      this.pendingRequests.set(message.requestId, {
        resolve,
        reject,
        timeout,
        shouldThrowError: _.isEqual(MESSAGE_TOKEN, "SAVE_AI_TUTOR_RESPONSE"),
      });

      const msg = JSON.stringify(message);
      const targetOrigin = getWorkbookOrigin();
      iframeRef.contentWindow.postMessage(msg, targetOrigin);
    });
  };

  forceReload = () => {
    let iframeRef = this.iframeRef;
    const { iframeIdSelector } = this.props;
    const activeIframeId = _.get(window, "__ACTIVE_WORKBOOK_IFRAME_ID", null);
    if (
      _.isEmpty(activeIframeId) ||
      !_.isEqual(activeIframeId, iframeIdSelector)
    )
      return;
    if (!iframeRef) {
      iframeRef = document.getElementById(iframeIdSelector);
    }

    //force reload the iframe
    if (iframeRef) {
      const currentSrc = iframeRef.src;
      iframeRef.src = "";
      setTimeout(() => {
        //get current src of iframe again, as it might have been changed since the timeout was triggered
        const liveSrc = iframeRef?.getAttribute?.("src");

        //update only if the src is same as the one when timeout was triggered, to avoid unnecessary reloads
        if (liveSrc === "") {
          iframeRef.src = currentSrc;
        }
      }, 10);
    }
  };
  handleMessageEventToWorkbook = () => {
    const {
      attachment,
      workbookMode,
      imageOrientation,
      disableArr,
      userInfo,
      enableArr,
      questionDetails,
      isDrawingQuestion,
      shouldShowViewInstructions,
      isWorksheetWebView,
      templateMetadata,
      assessmentId,
      assignmentId,
      showEditFrameOption,
    } = this.props;
    const attachmentId = getAttachmentIdForUploadedAttachment({ attachment });
    const isLocalAttachment = _.startsWith(attachmentId, "NEW");
    const workbookUrl = _.get(attachment, "metadata.workbookUrl", "");
    if (!attachment || _.isEmpty(attachment) || _.isNull(attachment)) {
      this.sendMessage({ MESSAGE_TOKEN: "CLEAR_WORKBOOK" });
    }

    const showEditFrameOptionValue = _.get(
      templateMetadata,
      "showEditFrameOption",
      showEditFrameOption
    );

    const canShowViewInstructions =
      shouldShowViewInstructions &&
      !_.isEmpty(assessmentId) &&
      !_.isEmpty(assignmentId);

    switch (workbookMode) {
      case WORKBOOK_MODE_TYPES["ADD_OR_EDIT_STUDENT_TEMPLATE"]:
      case WORKBOOK_MODE_TYPES["ADD_OR_EDIT_ATTACHMENT"]:
        this.sendMessage({
          MESSAGE_TOKEN: this.isWorkbookIntialised
            ? "LOAD_WORKBOOK"
            : "INIT_WORKBOOK",
          PAYLOAD: getWorkBookMessagePayload({
            mode: workbookMode,
            attachmentId: isLocalAttachment ? null : attachmentId,
            attachmentObj: isLocalAttachment
              ? _.omit(attachment, [
                  "id",
                  "attachmentId",
                  "questionAttachment",
                  "signedUrl",
                ])
              : {},
            workbookUrl,
            userInfo,
            showEditFrameOption: showEditFrameOptionValue,
          }),
        });
        break;

      default:
        this.sendMessage({
          MESSAGE_TOKEN: this.isWorkbookIntialised
            ? "LOAD_WORKBOOK"
            : "INIT_WORKBOOK",
          PAYLOAD: getWorkBookMessagePayload({
            imageOrientation,
            attachmentId,
            mode: workbookMode,
            disableArr,
            workbookUrl,
            userInfo,
            enableArr,
            questionDetails,
            isDrawingQuestion,
            shouldShowViewInstructions: canShowViewInstructions,
            isWorksheetWebView,
            templateMetadata,
            showEditFrameOption: showEditFrameOptionValue,
          }),
        });
        break;
    }
    if (!this.isWorkbookIntialised) {
      this.isWorkbookIntialised = true;
      if (
        this.iframeRef &&
        !_.isEqual(document.activeElement, this.iframeRef) &&
        _.get(this.props, "shouldFocusWorkbook", true)
      ) {
        this.iframeRef?.focus();
      }
    }
  };

  handleMessageFromWorkbook = async e => {
    const {
      onDiscardDirectly,
      onUpdateSuccessfully,
      onTemplateUpdated,
      onTemplateCreated,
      attachment,
      onAfterDiscardDirectly,
      updateAttachments,
      setToastMsg,
      portalType,
      setViewQuestion,
      onChangeData,
      iframeIdSelector,
    } = this.props;
    const message = e.data;
    const attachmentData =
      _.first(_.get(attachment, "attachments", [])) || attachment;
    const attachmentId = getAttachmentIdForUploadedAttachment({
      attachment: attachmentData,
    });

    let iframeRef = this.iframeRef;
    const activeIframeId = _.get(window, "__ACTIVE_WORKBOOK_IFRAME_ID", null);
    // Handle response messages for sendMessageV2

    if (
      _.isFunction(onChangeData) &&
      _.isString(message) &&
      _.includes(message, "CHANGE_AI_TUTOR_RESPONSE")
    ) {
      try {
        const responseData = JSON.parse(message) || {};
        const { PAYLOAD = {} } = responseData;
        onChangeData(PAYLOAD);
      } catch (e) {
        console.error("Error parsing response message:", e);
      }
    }

    if (
      _.isString(message) &&
      (message.includes("SAVE_AI_TUTOR_RESPONSE") ||
        message.includes("CHECK_CURRENT_VERSION") ||
        message.includes("CHECK_UPLOAD_RESPONSE"))
    ) {
      try {
        const responseData = JSON.parse(message) || {};
        const { MESSAGE_TOKEN, PAYLOAD = {} } = responseData;
        const requestId = PAYLOAD.requestId;
        if (
          _.includes(
            [
              "SAVE_AI_TUTOR_RESPONSE",
              "BTN_SUCCESS_RESPONSE",
              "CHECK_CURRENT_VERSION",
              "CHECK_UPLOAD_RESPONSE",
            ],
            MESSAGE_TOKEN
          ) &&
          this.pendingRequests &&
          this.pendingRequests.has(requestId)
        ) {
          const { resolve, reject, timeout } = this.pendingRequests.get(
            requestId
          );
          clearTimeout(timeout);
          this.pendingRequests.delete(requestId);

          if (attachmentId && MESSAGE_TOKEN === "SAVE_AI_TUTOR_RESPONSE") {
            const payload = { id: attachmentId };
            if (!_.isEmpty(portalType)) payload.portalType = portalType;

            const refetchedAttachment = await getAttachment(payload);
            if (updateAttachments) {
              updateAttachments({
                oldAttachment: attachmentData,
                newAttachment: refetchedAttachment,
              });
              resolve({
                oldAttachment: attachmentData,
                newAttachment: refetchedAttachment,
              });
            } else {
              resolve();
            }
          } else if (MESSAGE_TOKEN === "CHECK_CURRENT_VERSION") {
            resolve({ ...PAYLOAD });
          } else {
            resolve();
          }
          return;
        }
      } catch (e) {
        console.error("Error parsing response message:", e);
      }
    }

    switch (message) {
      case "DISCARD":
        this.setDialogBoxState("DISCARD");
        break;

      case "DISCARD_DIRECTLY":
        if (onDiscardDirectly) {
          onDiscardDirectly();
        }
        if (onAfterDiscardDirectly) {
          onAfterDiscardDirectly();
        }
        break;

      case "PARENT_ATTACHMENT_CREATION_FAILED":
        if (onDiscardDirectly) {
          onDiscardDirectly();
        }
        this.sendMessage({ MESSAGE_TOKEN: "CLEAR_WORKBOOK" });
        break;

      case "UPDATE_SUCCESSFUL":
        if (onUpdateSuccessfully) {
          onUpdateSuccessfully();
        }
        if (attachmentId) {
          const payload = { id: attachmentId };
          if (!_.isEmpty(portalType)) payload.portalType = portalType;

          const refetchedAttachment = await getAttachment(payload);
          if (updateAttachments) {
            updateAttachments({
              oldAttachment: attachmentData,
              newAttachment: refetchedAttachment,
            });
          }
        }
        if (onDiscardDirectly) {
          onDiscardDirectly();
        }

        break;

      case "WORKBOOK_IS_LOADING":
        this.countLoadingEvents += 1;
        this.setState({ showFullScreenLoader: true });
        break;

      case "WORKBOOK_IS_LOADED":
        this.countLoadingEvents -= 1;
        if (this.countLoadingEvents <= 0) {
          this.setState({ showFullScreenLoader: false, isLoaded: true });
          this.countLoadingEvents = 0;
        }
        break;

      case "WORKBOOK_LOAD_FROM_LOCAL_DIALOG": {
        this.setState({ showFullScreenLoader: false, isLoaded: true });
        this.countLoadingEvents = 0;
        break;
      }

      case "WORKBOOK_INTERNAL_ERROR":
        setToastMsg("toastMsgs:something_went_wrong");
        if (onDiscardDirectly) {
          onDiscardDirectly();
        }
        break;
      case "VIEW_QUESTION_CLICKED": {
        setViewQuestion?.();
        break;
      }
      case "LOGOUT_USER": {
        logoutUser();
        break;
      }
      case "VIEW_INSTRUCTIONS_CLICKED":
        this.setState({ instructionsModalVisible: true });
        break;
      case "CANVAS_FOCUSED":
        //to check multiple iframes, focus only if active iframe is this iframe
        if (
          _.isEmpty(activeIframeId) ||
          !_.isEqual(activeIframeId, iframeIdSelector)
        )
          return;
        if (!iframeRef) iframeRef = document.getElementById(iframeIdSelector);
        //if something is clicked inside workbook iframe, focus the iframe
        if (
          iframeRef &&
          !_.isEqual(document.activeElement, iframeRef) &&
          _.get(this.props, "shouldFocusWorkbook", true)
        ) {
          iframeRef?.focus?.();
        }
        break;
      default:
        try {
          if (_.startsWith(message, "NEW_ATTACHMENT")) {
            // trying to fetch the object returned from workbook
            const val = message.slice(
              "NEW_ATTACHMENT".length + 1,
              message.length
            );
            const newAttachment = _.get(JSON.parse(val), "attachemnt_data", {});
            if (onUpdateSuccessfully) {
              onUpdateSuccessfully(_.omit(newAttachment));
            }
            if (updateAttachments) {
              if (!_.isEmpty(attachmentData)) {
                updateAttachments({
                  oldAttachment: attachmentData,
                  newAttachment,
                });
              }
            }
            if (onDiscardDirectly) {
              onDiscardDirectly();
            }
          } else if (_.startsWith(message, "SAVE_FAILED")) {
            const val = message.slice("SAVE_FAILED".length + 1, message.length);
            const errorObject = JSON.parse(val);
            Sentry.captureMessage(`Save failed error message from workbook`, {
              level: "info",
              tags: {
                workbookMode: this.props.workbookMode,
              },
              extra: {
                ...errorObject,
              },
            });
          } else if (_.startsWith(message, "SCHOOL_TEMPLATE_UPDATED")) {
            const val = message.slice(
              "SCHOOL_TEMPLATE_UPDATED".length + 1,
              message.length
            );
            const data = JSON.parse(val);
            if (onTemplateUpdated) {
              onTemplateUpdated?.(_.get(data, "label"));
            }
          } else if (_.startsWith(message, "SCHOOL_TEMPLATE_CREATED")) {
            const val = message.slice(
              "SCHOOL_TEMPLATE_CREATED".length + 1,
              message.length
            );
            const data = JSON.parse(val);
            if (onTemplateCreated) {
              onTemplateCreated?.(_.get(data, "label"));
            }
          }
        } catch (e) {}
    }
  };
  /* iframe messaging code ends here */

  setDialogBoxState = currentDialogAction => {
    this.setState(prevState => ({
      currentDialogAction,
    }));
  };

  onCloseDialogBox = () => {
    this.setDialogBoxState(null);
  };

  onDialogConfirmClick = () => {
    const { onDiscardDirectly } = this.props;
    if (onDiscardDirectly) {
      onDiscardDirectly();
    }
  };

  getCorrectFileByWorkbookMode = () => {
    const {
      attachment,
      workbookMode,
      imageOrientation,
      disableArr,
      userInfo,
      usePublicUrl,
      enableArr,
      templateMetadata,
      showEditFrameOption,
    } = this.props;
    const attachmentData =
      _.first(_.get(attachment, "attachments", [])) || attachment;
    let file = {
      ...(attachmentData || {}),
    };
    const attachmentId = getAttachmentIdForUploadedAttachment({
      attachment: attachmentData,
    });
    const isLocalAttachment = _.startsWith(attachmentId, "NEW");
    /**Snp visitors can't open workbook using url as they don't have feature flags.
     * So, open workbook using public url
     */
    if (ACLStore.can(SNPv2_VISITOR_PORTAL_PERM_GROUP) || usePublicUrl) {
      return { ...file, url: _.get(attachmentData, "metadata.publicUrl", "") };
    }
    const showEditFrameOptionValue = _.get(
      templateMetadata,
      "showEditFrameOption",
      showEditFrameOption
    );
    switch (workbookMode) {
      case WORKBOOK_MODE_TYPES["ADD_OR_EDIT_STUDENT_TEMPLATE"]:
      case WORKBOOK_MODE_TYPES["ADD_OR_EDIT_ATTACHMENT"]:
        file = {
          url: this.loadWorkbookCachedVersion
            ? WORK_BOOK_URL
            : getWorkBookUrl({
                mode: workbookMode,
                attachmentId: isLocalAttachment ? null : attachmentId,
                showEditFrameOption: showEditFrameOptionValue,
                attachmentObj: isLocalAttachment
                  ? _.omit(attachment, [
                      "id",
                      "attachmentId",
                      "isRead",
                      "questionAttachment",
                      "signedUrl",
                    ])
                  : {},
                userInfo,
              }),
          mimeType: "image/jpg",
          type: "IMAGE",
        };
        break;
      case WORKBOOK_MODE_TYPES["WORKBOOK_TEMPLATE_PREVIEW"]:
        file = {
          ...file,
          url: this.loadWorkbookCachedVersion
            ? WORK_BOOK_URL
            : _.get(
                attachmentData,
                "metadata.publicUrl",
                getWorkBookUrl({
                  imageOrientation,
                  attachmentId,
                  mode: "WORKBOOK_FEEDBACK_VIEW",
                  disableArr,
                  userInfo,
                  enableArr,
                  showEditFrameOption: showEditFrameOptionValue,
                })
              ),
        };
        break;
      case WORKBOOK_MODE_TYPES["AI_TUTOR_V2"]:
      case WORKBOOK_MODE_TYPES["AI_TUTOR_RESOURCE"]:
      case WORKBOOK_MODE_TYPES["AI_TUTOR_VIEW_V2"]:
        file = {
          ...file,
          url: this.loadWorkbookCachedVersion
            ? WORK_BOOK_URL
            : getWorkBookUrl({
                attachmentId,
                attachmentObj: {
                  url: _.get(attachmentData, "url", ""),
                  metadata: {
                    isWorkbookWithPageView: true,
                    isNewBackgroundToolbarEnabled: true,
                    isNewShapesToolbarEnabled: true,
                    numOfPages: 1,
                    workbookUrl: _.get(
                      attachmentData,
                      "metadata.workbookUrl",
                      ""
                    ),
                  },
                },
                mode: workbookMode,
                disableArr,
                userInfo,
                enableArr,
                showEditFrameOption: showEditFrameOptionValue,
              }),
          id: this.props.iframeIdSelector,
        };
        break;
      default:
        file = {
          ...file,
          url: this.loadWorkbookCachedVersion
            ? WORK_BOOK_URL
            : getWorkBookUrl({
                imageOrientation,
                attachmentId,
                attachmentObj: _.omit(attachment, [
                  "icon",
                  "attachmentId",
                  "isRead",
                  "questionAttachment",
                  "signedUrl",
                ]),
                mode: workbookMode,
                disableArr,
                userInfo,
                enableArr,
                showEditFrameOption: showEditFrameOptionValue,
                templateMetadata,
              }),
          id: this.props.iframeIdSelector,
        };
        break;
    }

    return file;
  };

  iframeLoadEvent = iframeReference => {
    const { iframeIdSelector } = this.props;
    if (iframeReference) {
      this.iframeRef = iframeReference;
    } else {
      const getIframe = document.getElementById(iframeIdSelector);
      if (getIframe) {
        this.iframeRef = getIframe;
      }
    }

    this.handleMessageEventToWorkbook();
  };

  workbookCachedIframeComponent = () => {
    const {
      t,
      shouldShowGiveFeedbackButton,
      iframeIdSelector,
      parentRef,
    } = this.props;
    const { isLoaded, waitForRef } = this.state;
    return (
      <>
        {!waitForRef && !this.isWorkBookPreLoaded && (
          <WorkbookIframePortal
            onIframeLoad={this.iframeLoadEvent}
            iframeIdSelector={iframeIdSelector}
            parentRef={parentRef}
            enableFocusTrap={this.enableFullscreenFocusTrap}
          />
        )}

        {shouldShowGiveFeedbackButton && isLoaded && (
          <div className={classes.container}>
            <div
              className={classes.feedbackButton}
              onClick={this.onClickGiveFeedback}
              data-test-id={"workbook-showGiveFeedbackModal"}
            >
              <GiveFeedbackIcon width={16} height={16} />
              <span className={classes.feedbackButtonText}>
                {t("common:give_feedback_text")}
              </span>
            </div>
          </div>
        )}
      </>
    );
  };

  loaderComponent = () => {
    const {
      invokeWorkbookCustomLoader,
      showSeparateLoader,
      usePublicUrl,
    } = this.props;
    const { showFullScreenLoader } = this.state;
    const shouldShowLoader =
      !invokeWorkbookCustomLoader && showFullScreenLoader && !usePublicUrl;
    if (shouldShowLoader) {
      if (showSeparateLoader) {
        return (
          <div className={classes.loader}>
            <Loading />
          </div>
        );
      }

      return <FullScreenLoader />;
    }

    return null;
  };

  closeViewInstructionsModal = () => {
    this.setState({ instructionsModalVisible: false });
  };

  renderComponent = () => {
    const {
      t,
      shouldShowGiveFeedbackButton,
      courseId,
      portalType,
      assessmentId,
      assignmentId,
      shouldShowViewInstructions,
    } = this.props;
    const {
      currentDialogAction,
      isLoaded,
      instructionsModalVisible,
    } = this.state;

    const canShowViewInstructions =
      shouldShowViewInstructions &&
      !_.isEmpty(assessmentId) &&
      !_.isEmpty(assignmentId);

    return (
      <>
        {this.loadWorkbookCachedVersion ? (
          this.workbookCachedIframeComponent()
        ) : (
          <FileViewer
            file={this.getCorrectFileByWorkbookMode()}
            onClickGiveFeedback={this.onClickGiveFeedback}
            shouldShowGiveFeedbackButton={
              shouldShowGiveFeedbackButton && isLoaded
            }
          />
        )}

        {currentDialogAction && (
          <DialogueBox
            modalTitle={DIALOGUE_INFO[currentDialogAction].title({
              t,
            })}
            modalBody={DIALOGUE_INFO[currentDialogAction].modalBody({ t })}
            button1={DIALOGUE_INFO[currentDialogAction].cancelButtonText(t)}
            button2={DIALOGUE_INFO[currentDialogAction].confirmButtonText(t)}
            onClickButton1={this.onCloseDialogBox}
            toggleDialogueBoxDisplay={this.onCloseDialogBox}
            onClickButton2={this.onDialogConfirmClick}
            button1Props={styles.cancelButtonProps}
            button1Styles={styles.cancelButtonStyle}
            modalBodyStyle={styles.modalBodyStyle}
            size={"auto"}
          />
        )}

        {canShowViewInstructions ? (
          <UIModal
            isOpen={instructionsModalVisible}
            onRequestClose={this.closeViewInstructionsModal}
            modalContent={classes.viewInstructionsModal}
          >
            <CompactLEPreview
              assessmentId={assessmentId}
              assignmentId={assignmentId}
              portalType={portalType}
              onCloseClick={this.closeViewInstructionsModal}
              showAttachmentItemV3={true}
              showFullScreenButton={false}
              attachmentItemHeight={100}
              isFullScreenLE={false}
              showEmptyState={true}
              showPostSettings={false}
              showAssignmentActionsButton={false}
              courseId={courseId}
              showCloseButton={true}
              isWorkbookMode={true}
            />
          </UIModal>
        ) : null}

        {this.loaderComponent()}
      </>
    );
  };

  onClickGiveFeedback = () => {
    const { setShowGiveFeedbackModal } = this.props;
    if (setShowGiveFeedbackModal) {
      setShowGiveFeedbackModal();
    }
  };

  render() {
    const { isFullScreen } = this.props;
    return isFullScreen ? (
      <UIModal isFullScreen={true} isOpen={true} shouldFocusAfterRender={false}>
        {this.renderComponent()}
      </UIModal>
    ) : (
      this.renderComponent()
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const portalType = _.get(ownProps, "portalType", "");
  const isResourceLibrary = portalType == "RESOURCE_LIBRARY";
  const activeTab = _.get(state, "login.activeTab", "");
  const enableAutoSubmit = _.get(state, "worksheet.enableAutoSubmit", false);

  const isCommunity = activeTab == "community";
  const isToddleLibrary = activeTab == TODDLE_LIBRARY;
  const isCustomUserInfo = isCommunity || isResourceLibrary || isToddleLibrary;
  const userInfo = isCustomUserInfo
    ? getUserInfo({ portalType: _.toUpper(portalType) })
    : getUserInfo();

  const courseId = _.get(state, "teacher.selected_class.selected_course");

  return {
    userInfo,
    enableAutoSubmit,
    courseId,
  };
};

const mapActionCreators = {
  setToastMsg,
  setGlobalTrayEnabledState,
  updateIsQuestionTheaterModeEnable,
  updateEnableAutoSubmit,
};

Workbook.defaultProps = {
  attachment: {},
  workbookMode: WORKBOOK_MODE_TYPES["WORKBOOK_MULTIPAGE_ADD_OR_EDIT"],
  imageOrientation: 0,
  isFullScreen: true,
  disableArr: [],
  enableArr: [],
  iframeIdSelector: WORKBOOK_IFRAME_ID_SELECTORS["DEFAULT"],
  shouldFocusWorkbook: true,
  shouldEnablePreload: true,
  usePublicUrl: false,
  enableAutoSubmit: false,
  shouldShowViewInstructions: false,
  showEditFrameOption: false,
};

Workbook.propTypes = {
  workbookMode: PropTypes.string,
  onDialogConfirmClick: PropTypes.func,
  onUpdateSuccessfully: PropTypes.func,
  onDiscardDirectly: PropTypes.func,
  attachment: PropTypes.object,
  imageOrientation: PropTypes.number,
  isFullScreen: PropTypes.bool,
  disableArr: PropTypes.array,
  iframeIdSelector: PropTypes.string,
  shouldFocusWorkbook: PropTypes.bool,
  shouldEnablePreload: PropTypes.bool,
  usePublicUrl: PropTypes.bool,
  enableArr: PropTypes.array,
  enableAutoSubmit: PropTypes.bool,
  shouldShowViewInstructions: PropTypes.bool,
  workbookCompRef: PropTypes.object,
  showEditFrameOption: PropTypes.bool,
};
export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: "common" })
)(Workbook);
